document.addEventListener("DOMContentLoaded", () => {

    let quickAddDrawer = document.querySelector('#cart-popup');

    if (quickAddDrawer) {
        let observer = new MutationObserver(mutations => {
            mutations.forEach(m => {
                if (m.addedNodes.length) {
                    if (typeof BSS_B2B === "object") {
                        BSS_B2B.observer.cartSubject.listenCartCheckout();
                    }
                }
            });
        });

        observer.observe(quickAddDrawer, {
            childList: true,
            subtree: true
        });
    }
    changeVarriant()

});

function changeVarriant() {
    let buttonChangeVariant = document.querySelectorAll('[bss-b2b-variant-click]');
    if (buttonChangeVariant.length) {
        buttonChangeVariant.forEach(element => {
            element.addEventListener('click', async () => {
                if (typeof BSS_B2B !== "object") return;
                const res = await BSS_B2B.storage.productStorage.load();
                if (
                    (res.notExistProductIds && res.notExistProductIds.length > 0) ||
                    (res.productIds && res.productIds.length > 0) ||
                    (res.variantIds && res.variantIds.size > 0)
                ) {
                    setTimeout(async () => {
                        await BSS_B2B.observer.productSubject.notifyObserver(
                        'LazyProduct',
                        'LoadedLazyProduct',
                        { ...res }
                        );
                        changeVarriant()
                    }, 2000);
                    
                }
            });
        });
    }
}